import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import './GroupDescription.css';
import { useTranslation } from 'react-i18next';
import PouchDB from 'pouchdb-browser';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import Comment from '../comment/Comment';
import GroupElement from '../group_list_element/GroupElement';
import DistillationDescription from '../distillation_description/DistillationDescription';
import ChronologyDescription from '../chronology_description/ChronologyDescription';
import Star from '../ui/Stars';
import { toast } from 'react-toastify';
import { urls } from '../router/urls';
import Skeleton from 'react-loading-skeleton';
import ReactTooltip from 'react-tooltip';
import ShareResourceModal from '../ui/ShareResourceModal';
import { addView } from '../functions/functions';

const GroupDescription = ({
  match: {
    params: { group_id }
  }
}) => {
  const db = PouchDB('gestor_contenidos_db');
  const db_agrupaciones = PouchDB('gestor_contenidos_agrupaciones');
  const { t, i18n } = useTranslation();
  const [numPaginas, setNumPaginas] = useState(0);
  const [data, setData] = useState({});
  const [down, setDown] = useState(false);
  const [datos, setDatos] = useState({});
  const [recursosPagina, setRecursosPagina] = useState([]);

  const getGroup = useCallback(() => {
    axios
      .get(urls.url_api + `/api/resource-objects-grouping/${group_id}/`)
      .then(response => {
        const object = response.data;
        setData(object);
        setNumPaginas(Math.ceil(object.grouping_resources.length / 5));
      });
  }, [group_id, setNumPaginas, setData]);

  const getGroupInfo = useCallback(() => {
    axios
      .get(urls.url_api + `/api/resource-objects/${group_id}/`)
      .then(response => {
        const object = response.data;
        setDatos(object);
      });
  }, [group_id, setDatos]);

  const checkIfDownloaded = useCallback(id => {
    db.get(id)
      .then(() => {
        setDown(true);
      })
      .catch(err => {
        if (err.error) {
          setDown(false);
        }
      });
  }, [db, setDown]);

  const cambioPagina = d => {
    let selected = d.selected;
    let aux_data = data['grouping_resources'].slice(
      selected * 5,
      (selected + 1) * 5
    );
    setRecursosPagina(aux_data);
  };

  const downloadGroup = () => {
    axios
      .get(urls.url_api + `/api/resource-objects-grouping/${group_id}/`)
      .then(response => {
        //save group metadata
        let group_data = response.data;

        db_agrupaciones
          .put({
            _id: group_id,
            group: group_data
          })
          .then(response => {
            //succefully saved metadata
            toast.dismiss();
            toast.success(t('toast_guardado'));
            checkIfDownloaded(group_id);
          })
          .catch(function(err) {
            if (err.name === 'conflict') {
              toast.dismiss();
              toast.warn(t('toast_descargado_prev'));
              checkIfDownloaded(group_id);
              return false;
            }
          });
      });
  };

  const handleObjectDownloadClick = () => {
    // get metadata
    axios
      .get(urls.url_api + `/api/resource-objects/${group_id}/`)
      .then(response => {
        //save metadata
        let object = response.data;

        let date = new Date();
        const json_date = date.toISOString();

        db.put({
          _id: object.id,
          object: object,
          date_downloaded: json_date
        })
          .then(response => {
            //succefully saved metadata
            toast.dismiss();
            toast.success(t('toast_guardado'));
            checkIfDownloaded(group_id);

            //save attachment
          })
          .catch(function(err) {
            if (err.name === 'conflict') {
              toast.dismiss();
              toast.warn(t('toast_descargado_prev'));
              checkIfDownloaded(group_id);
              return false;
            }
          });
      });
    axios.post(urls.getResourceNumberTimesDownloadedURL(group_id));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getGroup();
    getGroupInfo();
    checkIfDownloaded(group_id);
    i18n.changeLanguage(localStorage.getItem('lang'));
    addView(group_id);
  }, [checkIfDownloaded, getGroup, getGroupInfo, group_id, i18n]);

  return (
    <div>
      <ReactTooltip />
      <div
        style={{ backgroundColor: '#FAC600', width: '100%', height: '12px' }}
      >
        {' '}
      </div>

      {/* Miga de pan */}
      <ol className="breadcrumb m-0">
        <li className="breadcrumb-item">
          <Link to="/" title={'dashboard'}>
            <i className="fal fa-home"> </i>
            <span> {t('catalogo')}</span>
          </Link>
        </li>
        <li className="breadcrumb-item active">
          <span> {data['id'] ? data['title'] : ''}</span>
        </li>
      </ol>

      {datos['image'] ? (
        <div className="d-flex row" style={{ padding: '0px 30px 15px 30px' }}>
          <img
            alt={''}
            src={urls.url_api + datos['image']}
            style={{
              width: '-webkit-fill-available',
              maxHeight: '281px',
              maxWidth: '581px'
            }}
          />
        </div>
      ) : (
        <div className="d-flex row" style={{ padding: '0px 30px 15px 30px' }}>
          <div
            style={{
              width: '-webkit-fill-available',
              maxHeight: '281px',
              maxWidth: '581px'
            }}
          >
            <Skeleton height={180} />
          </div>
        </div>
      )}

      {data['title'] ? (
        <div className="row">
          <span className="resources-title object-title-pwa">
            {data['title']}
          </span>
        </div>
      ) : (
        <div className="d-flex row" style={{ padding: '0px 30px 15px 30px' }}>
          {' '}
          <Skeleton width={350} height={50} />
        </div>
      )}

      <div className="row options">
        <span className="titles-pwa">
          {' '}
          {data['grouping_resources']
            ? `${data['grouping_resources'].length}  ${t('cantidad_recursos')}`
            : ''}
        </span>
      </div>

      <div className={'row options'}>
        <div className="col-sm-4 col-12">
          <div className={'mb-3 d-inline stars-icon-pwa'}>
            <Star rating={data['id'] ? data['qualification'] : ''} />
            <span className="stars-pwa fw-900 text-blue">
              {' '}
              {data['id'] ? data['qualification'] + '.0' : ''}
            </span>
          </div>
        </div>
        <div className="col-sm-4 col-auto options-pwa link-calificacion">
          <button
            className="options-pwa"
            href={urls.url_api + datos['url'] || ''}
            target="_blank"
            onClick={() => window.open(urls.url_api + datos['url'] || '', "_blank")}
            rel="noopener noreferrer"
          >
            <span>{t('califica_recurso')} </span>
          </button>
          <i className={'fal fa-angle-right'}> </i>
        </div>
        <div className="col-sm-4 col-auto link-calificacion">
          <button
            className="options-pwa"
            data-toggle="modal"
            data-target=".modal-valoration"
          >
            <span>
              {t('ver_comentarios')} (
              {datos['id'] ? datos['annotation'].length : '0'})
            </span>
          </button>
          <i className={'fal fa-angle-right ml-1'}> </i>
        </div>
      </div>

      {/** iconos opciones **/}

      <div
        className={'row options demo icon-pwa'}
        style={{ marginBottom: '0 0 6px 5px !important' }}
      >
        {/* boton de descarga*/}

        {datos['id'] ? (
          datos['rights'].description.download ? (
            down ? (
              <button
                title={t('recurso_descargado')}
                className="btn btn-success btn-lg btn-icon rounded-circle waves-effect waves-themed"
                type="button"
              >
                <span className="far fa-check"> </span>{' '}
              </button>
            ) : (
              <button
                onClick={() => {
                  handleObjectDownloadClick();
                  downloadGroup();
                }}
                title={t('guardar_recurso')}
                className="btn btn-default btn-lg btn-icon rounded-circle waves-effect waves-themed"
                type="button"
              >
                <span className="far fa-cloud-download"> </span>{' '}
              </button>
            )
          ) : (
            ''
          )
        ) : (
          ''
        )}

        {/* boton favoritos */}
        <div
          className="d-inline show"
          title=""
          data-tip={t('agregar_favoritos')}
        >
          <button
            data-toggle="dropdown"
            className="btn btn-outline-default btn-lg btn-icon rounded-circle waves-effect waves-themed btn-favorites"
          >
            <i className="fas fa-heart"> </i>
          </button>

          <div
            className="dropdown-menu dropdown-md p-4"
            x-placement="bottom-start"
            style={{
              position: 'absolute',
              willChange: 'top, left',
              top: '442px',
              left: ' 24px'
            }}
          >
            <p className="dropdown-option ff-ws">
              <a
                className="link-favorite"
                target="_blank"
                rel="noopener noreferrer"
                href={urls.url_api + urls.login}
              >
                {t('ingresar_colombia_aprende')}{' '}
                <span className="fw-500">{t('colombia_aprende')}</span>.
                <button className="btn btn-outline-info btn-pills btn-block waves-effect waves-themed mt-2">
                  {t('iniciar_sesion_registro')}
                </button>
              </a>
            </p>
          </div>
        </div>

        {/* boton opciones */}

        <div className="d-inline show" title="" data-tip={t('opciones')}>
          <button
            data-toggle="dropdown"
            className="btn btn-outline-default btn-lg btn-icon rounded-circle waves-effect waves-themed link-share"
          >
            <i className="fas fa-ellipsis-h"> </i>
          </button>

          <div
            className="dropdown-menu dropdown-md p-4"
            x-placement="bottom-start"
            style={{
              position: 'absolute',
              willChange: 'top, left',
              top: '442px',
              left: ' 24px'
            }}
          >
            <p className="dropdown-option ff-ws">
              <a
                className="link-favorite"
                target="_blank"
                rel="noopener noreferrer"
                href={urls.url_api + urls.login}
              >
                {t('ingresar_colombia_aprende')}{' '}
                <span className="fw-500">{t('colombia_aprende')}</span>.
                <button className="btn btn-outline-info btn-pills btn-block waves-effect waves-themed mt-2">
                  {t('iniciar_sesion_registro')}
                </button>
              </a>
            </p>
          </div>
        </div>

        <button
          className="btn btn-outline-default btn-lg btn-icon rounded-circle waves-effect waves-themed"
          data-toggle="modal"
          data-target="#modal-shortcut"
          data-tip={t('compartir')}
        >
          <i className="far fa-share-alt"> </i>
        </button>
      </div>

      <ShareResourceModal
        resource_id={datos['id']}
        url={datos['id'] ? urls.url_api + datos['url'] : ''}
        quote={datos['id'] ? datos['general'].title.value : ''}
      />

      <div className="row options">
        <h5 className="info-pwa">
          {t('descripcion')}
          <small className="mb-0">
            {data['id'] ? data['description'] : ''}
          </small>
        </h5>
      </div>

      {/* grafico */}

      <div className="row grafica-pwa">
        <img
          src={process.env.PUBLIC_URL + '/img/grafica-b.png'}
          alt="logo"
          aria-roledescription="logo"
        />
      </div>

      {/* Palabras Clave */}

      <div className="row options">
        <h1 className="titles-pwa">
          <div className="mb-3">{t('palabra_clave')}</div>

          {data['general']
            ? data['general'].keyword[0].value.map((elemento, index) => {
                return (
                  <span
                    className="keyword badge badge-light badge-pill ff-rb"
                    key={index}
                  >
                    {elemento}
                  </span>
                );
              })
            : ''}
        </h1>
      </div>

      {/* Listado */}
      <div className="row">
        <span className="listado-title object-title-pwa">
          {data['grouping_resources']
            ? data['grouping_resources'].length
              ? 'Listado de ' + data['grouping_resources'].length + ' recursos'
              : ''
            : ''}
        </span>
      </div>

      {data['grouping_resources'] ? (
        data['group_type'] === 'Agregación' ? (
          <>
            {recursosPagina.map((elemento, index) => {
              return (
                <GroupElement
                  key={index}
                  is_group={elemento['group_type']}
                  stars={elemento['qualification']}
                  taxon={elemento['taxon_path']}
                  descripcion={elemento['description']}
                  nombre={elemento['title']}
                  format={elemento['technical_format']}
                  id={elemento['resource_grouped']}
                  structured_group_data={elemento['structured_group_data']}
                  img={urls.url_api + elemento['image']}
                >
                  {' '}
                </GroupElement>
              );
            })}

            {data['grouping_resources'] ? (
              data['grouping_resources'].length ? (
                /* paginacion en colecciones*/
                <div className="row options-between tab-content">
                  <ReactPaginate
                    previousLabel={'«'}
                    nextLabel={'»'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={numPaginas}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={cambioPagina}
                    containerClassName={'pagination my-4'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                    pageLinkClassName={'page-link'}
                    pageClassName={'page-item'}
                    previousClassName={'page-item'}
                    nextClassName={'page-item'}
                    previousLinkClassName={'page-link'}
                    nextLinkClassName={'page-link'}
                    initialPage={0}
                  />
                </div>
              ) : (
                ''
              )
            ) : (
              ''
            )}
          </>
        ) : data['group_type'] === 'Destilación' ? (
          <DistillationDescription data={data} />
        ) : data['group_type'] === 'Cronología' ? (
          <ChronologyDescription data={data} />
        ) : (
          ''
        )
      ) : (
        ''
      )}

      {/* modal comentarios*/}

      <div
        className="modal fade modal-backdrop-transparent modal-valoration"
        aria-modal="true"
        style={{ paddingRight: '15px' }}
      >
        <div className="modal-dialog modal-dialog-right modal-md">
          <div className="modal-content">
            <div className="dropdown-header d-flex justify-content-between align-items-center w-100">
              <h4 className="m-0 text-secondary font-weight-bold py-3 roboto-pwa">
                {t('comentario')} (
                {datos['id'] ? datos['annotation'].length : '0'})
              </h4>
              <button
                type="button"
                className="close text-secondary position-absolute pos-top pos-right p-2 m-1 mr-2 py-3"
                data-dismiss="modal"
              >
                <span>
                  <i className="fal fa-times"> </i>
                </span>
              </button>
            </div>
            <div className="modal-body p-0">
              <div className="settings-panel">
                {datos['id'] ? (
                  /*cuando se carga el recurso verificar si tiene comentarios*/
                  datos['annotation'].length ? (
                    datos['annotation'].map((element, index) => {
                      return (
                        <Comment
                          key={index}
                          stars={element.get_rating}
                          time={element.human_date}
                          description={element.description.value}
                          username={element.user_name}
                        />
                      );
                    })
                  ) : (
                    <h4
                      id="reviewMessage"
                      className="text-center text-secondary fw-500 py-4"
                    >
                      {t('no_comentarios')}
                    </h4>
                  )
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupDescription;
